import { Chip, Stack, Typography } from '@mui/material'
import { alpha } from '@mui/material/styles'

import { useTranslation } from 'react-i18next'

import { VendorSearchState } from '../../../states/useVendorSearchState'
import { DEFAULT_OPTION_VALUE, options } from './constants'

type VendorFilterTypeProps = {
  filters: VendorSearchState['filters']
  search: VendorSearchState['search']
}

export function VendorFilterType(props: VendorFilterTypeProps) {
  const { filters, search } = props
  const { t } = useTranslation()

  const setSupplierType = (value: string) => {
    void search({ supplierType: value })
  }

  const selectedOption = options.find((opt) => {
    return opt.value === filters.supplierType
  })

  const value = selectedOption?.value ?? DEFAULT_OPTION_VALUE

  return (
    <Stack gap={1}>
      {options.map((option) => {
        let optionLabel = option.label as string
        const translatedOptionLabel = t(`marketplace:${option.value}Option`)
        if (translatedOptionLabel !== `${option.value}Option`) {
          optionLabel = translatedOptionLabel
        }

        const Icon = option.icon
        const isSelected = option.value === value

        return (
          <Chip
            key={option.value}
            clickable
            onClick={() => setSupplierType(option.value)}
            icon={<Icon fontSize="small" />}
            label={
              <Typography variant="body3" fontWeight={500}>
                {optionLabel}
              </Typography>
            }
            sx={{
              width: '100%',
              borderRadius: 3,
              border: 'none',
              backgroundColor: isSelected ? 'primary.main' : 'background.subtle',
              color: isSelected ? 'primary.contrastText' : 'text.primary',
              justifyContent: 'flex-start',
              '& .MuiChip-icon': {
                color: isSelected ? 'inherit' : 'text.secondary',
                ml: 1,
              },
              '&:hover': {
                backgroundColor: (theme) => (isSelected ? theme.palette.primary.dark : '#E5E5E5'),
              },
            }}
          />
        )
      })}
    </Stack>
  )
}
